<template>
    <div style="width: 100%; height: 99.5vh" v-if="!isMobile">
        <iframe
            src="https://sonphatgroup.vn/tin-tuc-ben-xe#scrollTop=0"
            style="width: 100%; height: 100%"
            frameborder="0"
        ></iframe>
    </div>

    <TrangChuMobileVue v-if="isMobile" />
</template>

<script>
import TrangChuMobileVue from "./Trang-Chu/index.vue";

export default {
    components: {
        TrangChuMobileVue,
    },
    computed: {
        isMobile: {
            get() {
                return this.$store.state.ManHinh.isMobile;
            },
            set(data) {
                this.$store.commit("ManHinh/Set", {
                    key: "isMobile",
                    data: data,
                });
            },
        },
    },
};
</script>
<style scoped></style>
